"use client";

import React from "react";
import { Zap, Dumbbell, Activity, Move } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const flowSteps = [{
  title: "Symptom Check",
  icon: Activity,
  description: "Identify warning signs like snoring, gasping, or chronic fatigue."
}, {
  title: "Sleep Study",
  icon: Zap,
  description: "Professional diagnostic testing to monitor breathing overnight."
}, {
  title: "Specialist Review",
  icon: Move,
  description: "Board-certified experts analyze data for a clinical diagnosis."
}, {
  title: "Treatment Plan",
  icon: Dumbbell,
  description: "Receive a personalized strategy for long-term health and rest."
}];
export default function TestingDayFlow() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section data-section-id="127664" id="the-diagnosis-path" className="relative bg-background py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `linear-gradient(to right, var(--color-foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--color-foreground) 1px, transparent 1px)`,
      backgroundSize: "32px 32px"
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10" ref={ref}>
        <div className={`text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 tracking-tight text-foreground">
            The Diagnosis Path
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            A clear, clinical process to identify your sleep apnea and start your journey 
            toward restorative sleep and better heart health.
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          {}
          <div className={`hidden md:block absolute top-1/2 left-[10%] right-[10%] h-[2px] border-t-2 border-dashed border-primary/20 -translate-y-1/2 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 drop-shadow-[0_0_8px_var(--color-primary)]" : "opacity-20 drop-shadow-none"}`} aria-hidden="true" />

          {}
          <div className={`md:hidden absolute top-[10%] bottom-[10%] left-1/2 w-[2px] border-l-2 border-dashed border-primary/20 -translate-x-1/2 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 drop-shadow-[0_0_8px_var(--color-primary)]" : "opacity-20 drop-shadow-none"}`} aria-hidden="true" />

          <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-4">
            {flowSteps.map((step, i) => {
            const Icon = step.icon;
            return <div key={step.title} data-index={i} className={`relative z-10 flex flex-col items-center w-full md:w-1/4 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
              transitionDelay: `${i * 150}ms`
            }}>
                  <div className="glass-effect w-full max-w-[260px] aspect-square p-6 rounded-2xl flex flex-col items-center justify-center text-center hover-lift bg-background/80 group border border-border shadow-sm">
                    {}
                    <div className="w-20 h-20 rounded-full bg-primary flex items-center justify-center mb-6 shadow-md transition-transform duration-300 group-hover:scale-110 group-hover:shadow-[0_0_15px_var(--color-primary)]">
                      <Icon className="w-10 h-10 text-primary-foreground" strokeWidth={1.5} aria-hidden="true" />
                    </div>
                    
                    {}
                    <h3 className="text-[22px] font-semibold leading-tight mb-2 text-foreground">
                      {step.title}
                    </h3>
                    
                    {}
                    <p className="text-sm text-muted-foreground hidden sm:block opacity-90">
                      {step.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}